import { createContext, useContext } from "react";
import { DEFAULT_CONTENT } from "@/constants/site";

const ContentContext = createContext(DEFAULT_CONTENT);

export const useContent = () => useContext(ContentContext);

export default ContentContext;
